/* kz-cro.js - header search box opens the predictive search modal; cart promo-code link */
(function () {
  function openSearch() {
    var s = document.querySelector('.header__search summary');
    if (!s) return;
    s.click();
    setTimeout(function () {
      var i = document.querySelector('.search-modal input[type="search"]');
      if (i) i.focus();
    }, 120);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest && t.closest('[data-kz-open-search]')) { e.preventDefault(); openSearch(); return; }
    var b = t.closest && t.closest('[data-kz-promo-apply]');
    if (b) {
      var f = b.closest('[data-kz-promo]');
      var v = f && f.querySelector('input[name="kz_code"]');
      var code = v && v.value.trim();
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    }
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key === 'Enter' && t.matches && t.matches('[data-kz-promo] input')) {
      e.preventDefault();
      var b = t.closest('[data-kz-promo]').querySelector('[data-kz-promo-apply]');
      if (b) b.click();
    } else if ((e.key === 'Enter' || e.key === ' ') && t.matches && t.matches('[data-kz-open-search]')) {
      e.preventDefault();
      openSearch();
    }
  });
})();
